<template>
  <ComplaintContainer />
</template>

<script lang="ts">
import Vue from "vue";
import ComplaintContainer from "@/components/complaints/complaint/container/ComplaintContainer.vue";

export default Vue.extend({
  components: {
    ComplaintContainer,
  },
});
</script>
